import { takeLatest } from "redux-saga/effects";
import {ActionConstants} from "../constants";
import validatePromocodeSaga from "./validatePromocodeSaga";
import validateStep1Saga from "./validateStep1Saga";
import getStatesSaga from "./getStatesSaga";
import validateStep2Saga from "./validateStep2Saga";
import resendVerificationSmsSaga from "./resendVerificationSmsSaga";
import createAccountSaga from "./createAccountSaga";

export default function* appSaga() {
    yield takeLatest(ActionConstants.VALIDATE_PROMOCODE, validatePromocodeSaga);
    yield takeLatest(ActionConstants.VALIDATE_STEP_1, validateStep1Saga);
    yield takeLatest(ActionConstants.GET_STATES, getStatesSaga);
    yield takeLatest(ActionConstants.VALIDATE_STEP_2, validateStep2Saga);
    yield takeLatest(ActionConstants.RESEND_VERIFICATION_SMS_ACTION, resendVerificationSmsSaga);
    yield takeLatest(ActionConstants.CREATE_ACCOUNT_ACTION, createAccountSaga);
}
